import Smartphones from 'Reports/views/TaxPaymentReport/TaxPaymentApproveFormView/containers/Smartphones'
import Tablets from 'Reports/views/TaxPaymentReport/TaxPaymentApproveFormView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TaxPaymentApproveFormView = getCurrentDeviceView(Smartphones, Tablets)

export default TaxPaymentApproveFormView
